import { render, staticRenderFns } from "./PeriodPane.vue?vue&type=template&id=38c7ed95&scoped=true"
import script from "./PeriodPane.vue?vue&type=script&lang=js"
export * from "./PeriodPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c7ed95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38c7ed95')) {
      api.createRecord('38c7ed95', component.options)
    } else {
      api.reload('38c7ed95', component.options)
    }
    module.hot.accept("./PeriodPane.vue?vue&type=template&id=38c7ed95&scoped=true", function () {
      api.rerender('38c7ed95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/org/components/org/PeriodPane.vue"
export default component.exports